import { createContext, useContext } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

interface AuthPageWrapperContextProps {
  cnBem: ReturnType<typeof createBemBlockBuilder>;
}

export const AuthPageWrapperContext =
  createContext<AuthPageWrapperContextProps>(null!);

export const useAuthPageWrapperContext = (): AuthPageWrapperContextProps =>
  useContext(AuthPageWrapperContext);
